import React, { forwardRef } from 'react';
import { RegularButton } from 'fronton-react';
import { Icon } from './icon';
import s from './styles.module.css';
export function CompareRef({ active = false, buttonText = '', size = 'l', ...props }, ref) {
    return (React.createElement(RegularButton, { ref: ref, className: active ? s.activeButton : s.button, variant: "pseudo", size: size, ...props, iconLeft: React.createElement(Icon, { active: active }) }, buttonText));
}
export const Compare = forwardRef(CompareRef);
//# sourceMappingURL=compare.js.map